import { injectIntl } from 'react-intl';
import { formValues } from 'utils/formValues';
import IdentityValidation from './IdentityValidation';
import config from './config';
import * as validation from './validation';

export const VALIDATION = validation;
export const CONFIG = config;

export default injectIntl(
  formValues('indvIdentPrefMethod', 'onlineAcceptance', 'canBypassSafeID', 'nextStepCode')(IdentityValidation),
);
